import { brandSuggestions } from '../../../mocks/quiz-data';

interface ResultSectionProps {
  answers: Record<number, string>;
  userName: string;
  isVisible: boolean;
}

export default function ResultSection({ answers, userName, isVisible }: ResultSectionProps) {
  if (!isVisible) return null;

  const answerValues = Object.values(answers);
  const valueCounts: Record<string, number> = {};
  
  answerValues.forEach(value => {
    valueCounts[value] = (valueCounts[value] || 0) + 1;
  });

  const dominantType = Object.entries(valueCounts).reduce((a, b) => 
    b[1] > a[1] ? b : a
  )[0];

  const resultType = ['professional', 'creative', 'friendly', 'strong'].includes(dominantType) 
    ? dominantType as keyof typeof brandSuggestions
    : 'professional';

  const result = brandSuggestions[resultType];

  const scrollToSuggestions = () => {
    const suggestionsSection = document.getElementById('suggestions-section');
    if (suggestionsSection) {
      suggestionsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="result-section" className="py-24 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full mb-6">
            <i className="ri-trophy-line text-4xl text-white"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Kết Quả Trắc Nghiệm
          </h2>
          <p className="text-xl text-gray-600">
            Chúc mừng <span className="font-bold text-teal-600">{userName}</span>! Phong cách thương hiệu phù hợp với bạn
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
          <div className="bg-gradient-to-r from-teal-500 to-teal-600 p-8 text-white text-center">
            <h3 className="text-3xl md:text-4xl font-bold mb-3">
              {result.title}
            </h3>
            <p className="text-xl text-white/90">
              {result.description}
            </p>
          </div>

          <div className="p-8 md:p-12">
            <div className="mb-10">
              <h4 className="text-2xl font-bold mb-6 text-gray-900 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                  <i className="ri-lightbulb-line text-xl text-teal-600"></i>
                </div>
                Gợi Ý Xây Dựng BrandName Cho {userName}
              </h4>
              <ul className="space-y-4">
                {result.tips.map((tip, index) => (
                  <li key={index} className="flex gap-4 items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0 mt-1">
                      <span className="text-teal-600 font-bold text-sm">{index + 1}</span>
                    </div>
                    <p className="text-lg text-gray-700 leading-relaxed">{tip}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-amber-50 rounded-2xl p-8 border border-amber-100">
              <h4 className="text-2xl font-bold mb-4 text-gray-900 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-200 rounded-lg">
                  <i className="ri-star-line text-xl text-amber-700"></i>
                </div>
                Ví Dụ BrandName
              </h4>
              <div className="flex flex-wrap gap-3">
                {result.examples.map((example, index) => (
                  <span
                    key={index}
                    className="px-6 py-3 bg-white rounded-full text-gray-800 font-semibold shadow-sm border border-amber-200"
                  >
                    {example}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-10 text-center">
              <button
                onClick={scrollToSuggestions}
                className="whitespace-nowrap px-10 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-lg font-semibold rounded-full hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 cursor-pointer"
              >
                Xem Hướng Dẫn Chi Tiết
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}